import { defineTextStyles } from '@chakra-ui/react'

export const textStyles = defineTextStyles({
  '2xs': {
    value: {
      fontSize: '2xs',
    },
  },
  xs: {
    value: {
      fontSize: 'xs',
    },
  },
  sm: {
    value: {
      fontSize: 'sm',
    },
  },
  md: {
    value: {
      fontSize: 'md',
    },
  },
  lg: {
    value: {
      fontSize: 'lg',
      letterSpacing: 'tighter',
    },
  },
  xl: {
    value: {
      fontSize: 'xl',
      letterSpacing: 'tighter',
    },
  },
  '2xl': {
    value: {
      fontSize: '2xl',
      letterSpacing: 'tighter',
    },
  },
  '3xl': {
    value: {
      fontSize: '3xl',
      letterSpacing: 'tighter',
    },
  },
  '4xl': {
    value: {
      fontSize: '4xl',
      letterSpacing: 'tighter',
    },
  },
  '5xl': {
    value: {
      fontSize: '5xl',
      letterSpacing: 'tighter',
    },
  },
  '6xl': {
    value: {
      fontSize: '6xl',
      letterSpacing: 'tighter',
    },
  },
  '7xl': {
    value: {
      fontSize: '7xl',
      letterSpacing: 'tighter',
    },
  },
  none: {
    value: {},
  },
  label: {
    value: {
      fontSize: 'xs',
      lineHeight: '1.25rem',
      fontWeight: 'bold',
      textTransform: 'uppercase',
      letterSpacing: '0.05em',
    },
  },
  labelXs: {
    value: {
      fontSize: 'xs',
      lineHeight: '1rem',
      fontWeight: 'bold',
      textTransform: 'uppercase',
      letterSpacing: '0.05em',
    },
  },
  label2xs: {
    value: {
      fontSize: '2xs',
      lineHeight: '0.75rem',
      fontWeight: 'bold',
      textTransform: 'uppercase',
      letterSpacing: '0.05em',
    },
  },
})
